var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "platform-icon",
      style: {
        "--platform-width": _vm.size + "px",
        "--platform-height": _vm.size + "px",
      },
    },
    [
      _vm.tippyDisabled
        ? [
            _c(_vm.currentPlatform.component, {
              tag: "component",
              attrs: { color: _vm.currentPlatform.color },
            }),
          ]
        : [
            _c(_vm.currentPlatform.component, {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    followCursor: true,
                    placement: "bottom-end",
                    delay: [600, 0],
                    content: _vm.currentPlatform.content,
                  },
                  expression:
                    "{ followCursor: true, placement: 'bottom-end', delay: [600, 0], content: currentPlatform.content }",
                },
              ],
              tag: "component",
              attrs: { color: _vm.currentPlatform.color },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }